"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setRecipientSelectedState_1 = require("../actions/setRecipientSelectedState");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('focusNextRecipient')(function focusNextRecipient(recipientWell, recipientToBlur, direction) {
    var indexToBlur;
    if (typeof recipientToBlur === 'number') {
        indexToBlur = recipientToBlur;
    }
    else {
        indexToBlur = recipientWell.recipients.indexOf(recipientToBlur);
    }
    if (indexToBlur >= 0) {
        var indexToFocus = Math.max(0, indexToBlur + direction);
        if (indexToFocus < recipientWell.recipients.length) {
            setRecipientSelectedState_1.default(recipientWell.recipients[indexToFocus], true);
        }
    }
});
//# sourceMappingURL=focusNextRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/focusNextRecipient.js
// module id = 3407
// module chunks = 2 3